const fledging ={
    label : 'Fledging',
    background : '#3B363F',
    textColor : '#fc6e83',
    typingBoxText : '#8e5568',
    typingText : '#8e5568',
    correct : '#dcccca',
    incorrect : "red"
}
  const cyberSpace={
     label:'LightGreen',
     background:'rgba(24,28,24,255)',
     textColor:'#9bc6b3',
     typeBoxText:'#00d882',
     typingText : '#00d882',
     correct : '#dcccca',
     incorrect : "red"
  }
  const coral={
     label:'Coral',
     background:'#7c878e',
     textColor:'#93c247', 
     typeBoxText:'#4b5257',
     typingText :'#4b5257',
     correct : '#bfcfdc',
     incorrect : "red"
  }
  
  const oliveTheme={
     label:'Olive',
     background:'#181c18',
     textColor:'#9578d3',
     typeBoxText:'#00FF00',
     typingText :'#00FF00',
     correct : '#dcccca',
     incorrect : "red"
  }
  const azureTheme={
     label:'Azure',
     background:'#eeebe2',
     textColor:'#080909',
     typeBoxText:'#99947f',
     typingText : '#99947f',
     correct : '#081426',
     incorrect : "#c87e74"
  }
  const DeepSkyBlueTheme={
     label:'DeepSkyBlue',
     background:'#081426',
     textColor:'#F4A460',
     typeBoxText:'black',
     typingText : '#ffbc90',
     correct : '#f6ddb7',
     incorrect : "#c84754"
  }
  const darksTheme={
     label:'Dark',
     background:'rgb(0,0,0)',
     textColor:'#DCDCDC',
     typeBoxText:'#DCDCDC',
     typingText : '#ffbc90',
     correct : '#DCDCDC',
     incorrect : "red"
  }

  const fleuristeTheme={
   label:'Fleuriste',
   background:'#c6b294',
   textColor:'#405a52',
   typeBoxText:'#64374d',
   typingText : '#64374d',
   correct : '#1d2922',
   incorrect : "#990000"
}
const chesseTheme={
   label:'CheeseCake',
   background:'#fdf0d5',
   textColor:'#8e2949',
   typeBoxText:'#d91c81',
   typingText : '#d91c81',
   correct : '#5a514f',
   incorrect : "#5cf074"
}
const desertTheme={
   label:'Desert oasis',
   background:'#fff2d5',
   textColor:'#d19d01',
   typeBoxText:'#0061fe',
   typingText : '#0061fe',
   correct : '#372c04',
   incorrect : "#76bb40"
}
const EarthTheme={
   label:'Earth song',
   background:'#292521',
   textColor:'#509452',
   typeBoxText:'#f5ae2d',
   typingText : '#f5ae2d',
   correct : '#e5c6a7',
   incorrect : "#7c2a33"
}
export const themeOptions = [
  { label: "Azure", value: azureTheme },
  { label: "ChesseCake", value: chesseTheme },
  { label: "Coral", value: coral },
  { label: "Desert oasis", value: desertTheme },
  { label: "DeepSkyBlue", value: DeepSkyBlueTheme },
  { label: "Dark", value: darksTheme },
  { label: "Earth song", value: EarthTheme },
  { label: "Fleuriste", value: fleuristeTheme },
  { label: "Fledging", value: fledging },
  { label: "LightGreen", value: cyberSpace },
  { label: "Olive", value: oliveTheme }
];